import { apiGet, apiJson } from './client';

export interface DotProfileLite {
  id: string;
  name: string;
  profile: unknown;
  created_at: number;
  updated_at: number;
}

interface ListResponse {
  profiles: DotProfileLite[];
}

interface UploadResponse {
  id: string;
  name: string;
  profile: unknown;
}

export async function listDotProfiles(): Promise<DotProfileLite[]> {
  const res = await apiGet<ListResponse>('/api/dot-profiles');
  return res.profiles ?? [];
}

export async function uploadDotProfile(
  name: string,
  profile: unknown,
  id?: string,
): Promise<UploadResponse> {
  return apiJson<UploadResponse>('POST', '/api/dot-profiles', {
    id,
    name,
    profile,
  });
}

export async function deleteDotProfile(id: string): Promise<void> {
  await apiJson('DELETE', `/api/dot-profiles/${encodeURIComponent(id)}`);
}
